const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion) {
  document.documentElement.classList.add('hl-motion-ready');
  const revealObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const observeSections = () => {
    document.querySelectorAll('[data-hl-reveal]:not(.is-visible)').forEach((element) => revealObserver.observe(element));
  };

  const globalMotionSelectors = [
    '.content-for-layout > .shopify-section:not(:first-child) > *',
    'main .product-grid__item',
    'main .resource-list__item',
    'main .hl-sport',
    'main .hl-feature',
    'main .hl-community__item',
    'main .hl-quote',
    'main .hl-contact-form-card',
    'main .hl-contact-details',
    'main .cart-items__table-row',
    'main .cart-page__summary',
  ].join(',');

  const enhanceMotion = (root = document) => {
    const candidates = [];

    if (root instanceof Element && root.matches(globalMotionSelectors)) candidates.push(root);
    root.querySelectorAll?.(globalMotionSelectors).forEach((element) => candidates.push(element));

    candidates.forEach((element, index) => {
      if (!(element instanceof HTMLElement) || element.hasAttribute('data-hl-reveal')) return;
      if (element.closest('[role="dialog"], .menu-drawer, .hl-nav__mega, .predictive-search, [data-hl-sports-carousel], [data-u-sector-carousel], [data-u-product-carousel]')) return;

      element.setAttribute('data-hl-reveal', '');
      element.style.setProperty('--hl-motion-order', String(index % 6));
    });

    observeSections();
  };

  let motionFrame = 0;
  const scheduleMotionEnhancement = (root = document) => {
    if (motionFrame) return;
    motionFrame = window.requestAnimationFrame(() => {
      motionFrame = 0;
      enhanceMotion(root);
    });
  };

  enhanceMotion();
  document.addEventListener('shopify:section:load', (event) => scheduleMotionEnhancement(event.target));

  const motionMutationObserver = new MutationObserver((records) => {
    const addedElement = records.flatMap((record) => [...record.addedNodes]).find((node) => node instanceof Element);
    if (addedElement) scheduleMotionEnhancement(document);
  });

  motionMutationObserver.observe(document.body, { childList: true, subtree: true });
}

const closeDesktopNavigation = (exception) => {
  document.querySelectorAll('.hl-nav__details[open]').forEach((details) => {
    if (details !== exception) details.removeAttribute('open');
  });
};

document.addEventListener('pointerdown', (event) => {
  const activeGroup = event.target.closest('.hl-nav__details');
  closeDesktopNavigation(activeGroup);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeDesktopNavigation();
    document.querySelector('.hl-nav__toplink')?.focus();
  }
});

const initializeHeaderLogoSwap = () => {
  const header = document.querySelector('#header-component');
  const scrollContainer = document.querySelector('.page-wrapper');

  if (!(header instanceof HTMLElement) || !(scrollContainer instanceof HTMLElement)) return;

  let frameId = 0;
  const updateHeaderState = () => {
    frameId = 0;
    header.toggleAttribute('data-hl-scrolled', scrollContainer.scrollTop > 24);
  };

  const requestHeaderUpdate = () => {
    if (frameId) return;
    frameId = window.requestAnimationFrame(updateHeaderState);
  };

  updateHeaderState();
  scrollContainer.addEventListener('scroll', requestHeaderUpdate, { passive: true });
};

initializeHeaderLogoSwap();
